const locales = {
  c4r: {
    form: {
      selectAll: 'All',
      selectNone: 'None',
      allSelected: 'All selected',
      noneSelected: 'None selected',
      selected: 'selected'
    },
    widgets: {
      category: {
        apply: 'Apply',
        unlock: 'Unlock',
        lock: 'Lock',
        clear: 'Clear',
        noResults: 'No results',
        noResultsMessage: 'Your search "{searchValue}" didn\'t match with any value.',
        cancel: 'Cancel',
        searchInfo: 'Search in {elements} elements',
        selectedItems: '{items, plural, one{# selected} other{# selected}}',
        all: 'All',
        search: 'Search'
      },
      bar: {
        all: 'All',
        selectedItems: '{items, plural, one{# selected} other{# selected}}',
        clear: 'Clear'
      },
      histogram: {
        all: 'All',
        selectedItems: '{items} selected',
        clear: 'Clear'
      },
      legend: {
        layerOptions: 'Layer options',
        hide: 'Hide',
        show: 'Show',
        layer: 'layer',
        opacity: 'Opacity',
        hideLayer: 'Hide layer',
        showLayer: 'Show layer',
        open: 'Open legend',
        close: 'Close',
        collapse: 'Collapse layer',
        expand: 'Expand layer',
        zoomLevel: 'Zoom level',
        zoomLevelTooltip: 'This layer is only visible at certain zoom levels',
        lowerThan: 'lower than',
        greaterThan: 'greater than',
        and: 'and',
        zoomNote: 'Note: this layer will display at zoom levels',
        notSupported: 'is not a known legend type',
        subtitles: {
          proportion: 'Radius range by',
          icon: 'Icon based on',
          strokeColor: 'Stroke color based on',
          color: 'Color based on'
        },
        max: 'Max',
        min: 'Min',
        maxCategories: 'Legend limited to {n} categories'
      },
      range: {
        clear: 'Clear',
        minLimit: 'min limit',
        maxLimit: 'max limit',
        minValue: 'min value',
        maxValue: 'max value'
      },
      table: {
        rowsPerPage: 'Rows per page',
        of: '{from}–{to} of {count}',
        moreThan: 'more than'
      },
      timeSeries: {
        speed: 'Speed',
        clear: 'Clear'
      },
      featureSelection: {
        drawPolygonMode: 'Polygon',
        drawRectangleMode: 'Rectangle',
        drawPolygonByDraggingMode: 'Lasso tool',
        drawCircleFromCenterMode: 'Circle',
        edit: 'Edit mask',
        clickToEdit: 'Click on the mask to edit it',
        clickToCreate: 'Click on the map to create a mask',
        selectTool: 'Select a {label}',
        selectMode: 'Select a mode',
        chooseSelectionMode: 'Choose a selection mode',
        applyMask: 'Apply mask',
        clearMask: 'Clear mask',
        remove: 'Remove',
        polygon: 'Polygon',
        point: 'Point',
        lineString: 'Line',
        invalid: 'Invalid geometry'
      },
      pie: {
        clear: 'Clear',
        selectedItems: '{items, plural, one{# selected} other{# selected}}',
        allSelected: 'All'
      },
      chartLegend: {
        next: 'Next page',
        prev: 'Previous page'
      }
    }
  }
};

export default locales;
